import { Component, Input, OnChanges } from '@angular/core'
import { Empresa } from '../../pkw-data/core/empresa.model'

@Component({
    selector: 'col-dashboard-extratos',
    templateUrl: './dashboard-extratos.component.html',
    styleUrls: ['./dashboard-extratos.component.scss']
})
export class DashboardExtratosComponent implements OnChanges {
    @Input() empresas: Empresa[]
    @Input() totalMaquinasCarentes: number

    empresa: Empresa

    constructor() {}

    ngOnChanges() {
        if (this.empresas && this.empresas.length) {
            this.empresa = this.empresas[0]
        }
    }

    atencaoAsMaquinas() {
        return this.totalMaquinasCarentes > 0
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/dashboard-extratos/dashboard-extratos.component.ts